import { useContext } from 'react';
import { LoadingContext, LoadingActionsContext } from '../contexts';

export const useLoading = () => useContext(LoadingContext);

export const useLoadingActions = () => useContext(LoadingActionsContext);
